module.exports = __webpack_public_path__ + "static/media/chat.75d52c17.svg";